import { apiClient } from '../../gateways/api'
import type { JobSchedule } from '../types/JobSchedule'

export { fetchJobSchedules }

const fetchJobSchedules = async (): Promise<JobSchedule[]> => {
  const { data } = await apiClient({
    url: '/rest/beheer/jobschedule',
    method: 'GET',
  })

  return data
}
